import React from 'react';

type TabHeaderProps = {
  label: string
}

export const TabHeader = ({
  label,
}: TabHeaderProps) => (
  <div className="row no-gutters page-content-container">
    <div className="col">
      <div className="d-flex flex-row justify-content-between">
        <h5>{label}</h5>
      </div>
    </div>
  </div>
);
